/**
 * ═══════════════════════════════════════════════════════════════════════════
 * YARDIM MERKEZİ — biçim
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * `/help` sitenin TEK yardım yüzeyi: "Dokümantasyon" ve "Yardım merkezi"
 * 18 Eyl 2026'da birleştirildi (kullanıcı kararı, gerekçe
 * `lib/site-links.ts`te). Tek sayfa olarak başladı, aynı gün SAYFALI yapıya
 * çevrildi: on kategori, otuz sekiz makale, her makale bir panel ekranı ya da
 * bir işlem.
 *
 * ---------------------------------------------------------------------------
 * 🔴 Neden `messages/{en,tr}.json` DEĞİL
 * ---------------------------------------------------------------------------
 * `packages/shared/src/help-center.ts` ile aynı gerekçe: çeviri dosyası
 * arayüz ETİKETLERİ için — bir düğme, bir sütun başlığı, bir hata. Otuz sekiz
 * makaleyi oraya koymak o dosyayı bir içerik yönetim sistemine çevirirdi.
 * Üstelik JSON'a yeni anahtar eklendiğinde HMR yetmiyor, PM2 restart
 * gerekiyor; her yazım düzeltmesi bir yeniden başlatma demekti.
 *
 * Sayfanın ETİKETLERİ (arama kutusu, "bu ekran panelde", ileri/geri) yine
 * `messages`ta — orada olması gereken şey tam olarak onlar.
 *
 * ---------------------------------------------------------------------------
 * 🔴 Neden VERİTABANI değil, kod
 * ---------------------------------------------------------------------------
 * Bir `help_articles` tablosu daha "doğru" görünürdü ve üç şey getirirdi:
 * migration, bir düzenleme ekranı ve boş bir tablo. Metinler ürünün
 * DAVRANIŞINI anlatıyor — davranış kodla değişiyor, kod dağıtımıyla. İkisi
 * aynı sürümde durursa "bu ekran şöyle çalışır" cümlesi ekranla birlikte
 * güncelleniyor; tabloda dursaydı ekran değişir, makale eski davranışı
 * anlatmaya devam ederdi ve kimse fark etmezdi.
 *
 * ---------------------------------------------------------------------------
 * 🔴 SAYI YAZMA KURALI
 * ---------------------------------------------------------------------------
 * Bu ağaçta plan fiyatı, kredi maliyeti ya da kota SAYISI GEÇMEZ. Onların tek
 * kaynağı `packages/shared/src/plans.ts` (fiyat/kota) ve `enums.ts`
 * (`CREDIT_COST`); bir yardım metnine kopyalanan rakam, fiyat kalibre edildiği
 * gün sessizce yalan olur ve kimsenin aklına burayı güncellemek gelmez.
 * Makaleler bunun yerine ilgili EKRANA ya da /pricing'e yönlendiriyor.
 *
 * İSTİSNA: bizim belirlemediğimiz, platformun ya da zamanlayıcının kendi
 * sayısı yazılabilir (senkron aralığı gibi — kaynağı
 * `apps/worker/src/sync/sync.scheduler.ts`teki cron).
 *
 * ---------------------------------------------------------------------------
 * 🔴 UYDURMA ÖZELLİK YOK
 * ---------------------------------------------------------------------------
 * Her cümle bugünkü koda ve bugünkü arayüz etiketlerine bakılarak yazıldı:
 * sütun adları `messages/tr.json` → `dashboard.<ekran>.col`dan, bağlayıcı
 * listeleri `connector.registry.ts` ve `store-connector.registry.ts`teki
 * `isImplemented()`ten, roller `dashboard.settings.team.role`den. Bir yardım
 * metninin yapabileceği en kötü şey, kullanıcıyı olmayan bir düğmeyi aramaya
 * göndermek.
 *
 * ---------------------------------------------------------------------------
 * Slug'lar DİLDEN BAĞIMSIZ
 * ---------------------------------------------------------------------------
 * `/tr/help/kampanyalar-ekrani` ile `/en/help/kampanyalar-ekrani` aynı
 * makale. Slug Türkçe ama ASCII ve iki dilde ORTAK: destek ekibi bir bilete
 * bağlantı yapıştırdığında okuyanın dili bağlantıyı kırmıyor, dil değiştirici
 * de aynı makalede kalıyor. (Aynı karar `packages/shared/src/help-center.ts`
 * kataloğunda da verildi.)
 */

/* ═══════════════════════════════════════════════════════════════════════════
   Bloklar
   ═══════════════════════════════════════════════════════════════════════════

   Markdown DEĞİL, yapılandırılmış blok. Markdown olsaydı arayüzün bir
   ayrıştırıcı taşıması ve ürettiği HTML'i temizlemesi gerekirdi — kendi
   yazdığımız metin için ödenecek gereksiz bir bedel. Vurgu gerektiğinde
   cümle yeniden yazılıyor. */

export type HelpBlock =
  | { type: 'p'; text: string }
  | { type: 'h3'; text: string }
  | { type: 'list'; items: readonly string[]; ordered?: boolean }
  /**
   * Sıralı yol.
   *
   * 🔴 Numara `::marker` ile değil ÜST ETİKET olarak basılıyor ("ADIM 2/4").
   * Sıra sayısı dolu bir daire içinde rozet olmaz, sessiz bir işaret olur —
   * panelin geri kalanında da geçerli olan karar.
   */
  | { type: 'steps'; items: readonly { title: string; text: string }[] }
  /**
   * Ad → açıklama çiftleri. Ekrandaki sütunları, filtreleri ve durum
   * etiketlerini anlatan blok; bu yardım merkezinin en çok kullanılan biçimi,
   * çünkü sorulan soru çoğu zaman "bu sütun ne demek".
   *
   * Tablo DEĞİL: tek bir açıklama sütunu var ve tablo dar ekranda kendi
   * kabında yatay kaydırma isterdi.
   */
  | { type: 'defs'; items: readonly { term: string; desc: string }[] }
  | { type: 'note'; title?: string; text: string }
  /**
   * Metnin ortasından çıkan tek bağlantı.
   *
   * `to` üç şeyden biri:
   *   • `article:<slug>`  → aynı yardım merkezindeki başka bir makale
   *   • `/pricing` gibi   → sitenin kendi sayfası (dil önekini `Link` ekler)
   *   • `https://…`       → dış adres; düz `<a>` ile basılır, çünkü
   *     `@/i18n/navigation`ın `Link`i mutlak adrese dil öneki eklemez.
   */
  | { type: 'link'; to: string; label: string; text: string };

/* ═══════════════════════════════════════════════════════════════════════════
   Kategori ve makale
   ═══════════════════════════════════════════════════════════════════════════ */

/**
 * Kategoriler panelin SOL MENÜSÜNÜ aynalıyor.
 *
 * Kendi başımıza bir bilgi mimarisi kurmadık ve kurmamalıyız: kullanıcı
 * yardımı, panelde bulunduğu yerin adıyla arıyor. "Kampanyalar" ekranındayken
 * takılan biri yardım merkezinde "Reklam" başlığını arar, bizim icat
 * ettiğimiz "Performans yönetimi" başlığını değil.
 *
 * `basics` ve `developers` menüde karşılığı OLMAYAN iki kategori: biri
 * panele girmeden önceki, öteki panelin dışındaki iş.
 */
export const HELP_CATEGORY_IDS = [
  'basics',
  'connections',
  'ads',
  'agent',
  'automation',
  'creative',
  'store',
  'account',
  'developers',
] as const;

export type HelpCategoryId = (typeof HELP_CATEGORY_IDS)[number];

export interface HelpArticleText {
  title: string;
  /** Liste kartındaki tek cümle. Gövdenin ilk paragrafını KESMİYOR: kesilen
      cümle çoğu zaman yarım kalıyor ve kartlar birbirine benziyor. */
  summary: string;
  /**
   * Panelde nerede — "Reklam · Kampanyalar". `null` = ekranı olmayan
   * kavramsal makale.
   *
   * Dile bağlı, çünkü menü başlıkları çevrili. Adres (`route`) makalenin
   * kendisinde ve dilden bağımsız.
   */
  where: string | null;
  blocks: readonly HelpBlock[];
}

export interface HelpArticle {
  /** Bütün dillerde ORTAK, ASCII, kalıcı. */
  slug: string;
  category: HelpCategoryId;
  /** Anlattığı panel ekranı; `null` = kavramsal makale. Dil öneki arayüzde. */
  route: string | null;
  tr: HelpArticleText;
  en: HelpArticleText;
}

/**
 * Makalenin istenen dildeki metni — `helpPicker(locale)` üretiyor (`catalog.ts`).
 *
 * 29 Eyl 2026'ya kadar burada `pickLocale` vardı: `tr` dışındaki her dil
 * İngilizceye düşüyordu. Artık on üç dil var; `tr` ve `en` makale dosyasından
 * olduğu gibi, diğer on bir dil İngilizce metnin her cümlesinin DeepL
 * çevirisinden (`content/i18n/<dil>.json`, `localizedDeep`). Çevirisi
 * olmayan cümle İngilizce kalıyor — yarım çevrilmiş bir makale boş
 * paragraftan iyidir.
 *
 * Blok TİPLERİ, bağlantı hedefleri ve slug'lar çevrilmiyor (`NON_TEXT_KEYS`):
 * `type: 'note'` ya da `to: '/pricing'` ekranda görünmüyor, kod onlara bakıyor.
 */
export type HelpTextPicker = (article: HelpArticle) => HelpArticleText;

/**
 * Bir `link` bloğunun hedefi çözülüyor.
 *
 * Üç biçim var ve üçü farklı basılıyor (bkz. `HelpBlock` → `link`):
 *   `article:<slug>` → yardım merkezi içi, dil öneki `Link`ten
 *   `/pricing`       → sitenin kendi sayfası, dil öneki `Link`ten
 *   `https://…`      → dış adres, düz `<a>`; `Link` mutlak adrese önek koymaz
 *
 * 🔴 Tanınmayan bir `article:` hedefi SESSİZCE düşmüyor — bağlantı yine
 * basılıyor ve 404'e gidiyor. Sessizce gizlemek, makaleyi yazarken slug'ı
 * yanlış yazan kişiye hiçbir şey söylemezdi; kırık bağlantı en azından
 * görülüyor.
 *
 * ⚠️ `catalog.ts`te DEĞİL burada duruyor ve bu bilinçli: bu fonksiyonu
 * blok çizici (istemci bileşeni) çağırıyor. `catalog.ts` bütün makalelerin
 * tam metnini import ediyor — oradan tek bir fonksiyon almak, iki dilin
 * tamamını tarayıcıya indirmek demekti.
 */
export function helpLinkHref(to: string): { href: string; external: boolean } {
  if (to.startsWith('article:')) {
    return { href: `/help/${to.slice('article:'.length)}`, external: false };
  }
  if (/^https?:\/\//.test(to)) return { href: to, external: true };
  return { href: to, external: false };
}
